import React, { Component } from 'react';
import './Termini.css';
//import tecu from '../../images/public/registeration/tecu.png';
import clos from '../../images/public/registeration/clos.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isTablet } from 'react-device-detect';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router} from "react-router-dom";
//import Benvenuto from '../Benvenuto/Benvenuto';
import { userLogoutFetch, getAllLatestContracts, acceptContracts } from '../../libs/fetch';
// import { workflowCreat, workflowState, updateWorkflow } from "../../libs/workflow";
import MPWorkFlow from "../../libs/workflow";
//import ScrollDialog from './ScrollDialog';
import tr from '../../libs/tr';
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import ChckBxAccR2 from '../../assets/components/checkbox/ChckBxAccR2';
import RoundCheckbox from '../../assets/components/checkbox/RoundCheckbox';
import HorizontalRadioButton from '../../assets/components/radiobtn/HorizontalRadioButton';
import Cookies from 'universal-cookie';
//import itabar1 from '../../images/public/registeration/nav1i.png';
//import engbar1 from '../../images/public/registeration/nav1e.png';
//import simplebar1 from '../../images/public/registeration/mobilenav1.png';
import TopBar from '../../assets/components/topbar/TopBar';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
//import miniArrow from '../../images/public/registeration/miniarrow.png';
import logo from '../../images/public/login/logo.png';
//import help from '../../images/public/userarea/tab5u.png';


let cookies = new Cookies;

// init user from storage
let user;

// init contracts object
let contracts = {
	terms: null, //popup
	privacy: null, // popup
	personal: null,
	marketing: null,
	marketing3rd: null
}

class Termini extends Component {

	constructor(props) {

		super(props);
		this.state = {
			step: '1',
			redirect: false,
			rCheckbox: true,
			outPut: false,
			checkBox1: true,
			checkBox2: true,
			radio1: false,
			radio2: true,
			radio3: false,
			radio4: true,
			userInfo: this.props.userInfo ? this.props.userInfo : null,
			userRegResponse: '',// just for Test delete later
			marketdataacc: 1,
			market3partyacc: 1,
			IdPrivacy: '',
			Idterms: '',
			Idpersonal: '',
			Idmarket3party: '',
			Idmarketdata: '',
			loadedData: false,
			privacy: 'privacy',
			privacyTitle: 'Privacy',
			terms: 'terms',
			termsTitle: 'Terms',
			personal: 'personal',
			personalTitle: 'Personal',
			marketing: 'marketing',
			marketingTitle: 'Marketing',
			marketing3rd: 'marketing3rd',
			marketing3rdTitle: 'Marketing3rd',
			market3party: 1,
			marketdata: 1,
			showTerms: false,
			showPrivacy: false,
			modal: false,
			alertClost: false,
			backto: '',
			mandatories: [],
			optionals: [],
			mandatories_consents: [],
			optionals_consents: [],
		};

		this.gotoBenvenutol = this.gotoBenvenutol.bind(this);
		this.handelOnClickTerms = this.handelOnClickTerms.bind(this);
		this.handelOnClickPrivacy = this.handelOnClickPrivacy.bind(this)
		this.handleClost = this.handleClost.bind(this);
	}

	componentDidMount() {
		// this.wf = new MPWorkFlow();
		//console.log('[Termini]', this.state);
		if (!localStorage.getItem('user')) {
			return this.props.history.push('/');
	}

	user = JSON.parse(localStorage.getItem('user'));
	//console.log('[Termini] @user', user);

	let backto = localStorage.getItem('backto');
	this.setState({ backto });

	try {
		let access_token = cookies.get('access_token');

		let params = {
			portal: "sci",
			language: tr.userlng().toLowerCase()
			}
			getAllLatestContracts(this, access_token, params).then((response) => {
				//console.log('[getAllLatestContracts] ', response)
				if (response === null) return;
				else {
					let mandatories = [];
					let optionals = [];
					let mandatories_consents = [];
					let optionals_consents = [];
					let privacy_id = null;
					let terms_sci_id = null;
					response.map(function (item_row) {
						item_row.map(function (item) {
							if (item.label === "privacy") privacy_id = item.id;
							if (item.label === "terms_sci") terms_sci_id = item.id;
							if (item.label !== "privacy") {
								if (item.mandatory === 1) {
									mandatories.push(item);
									mandatories_consents.push(0); //filling all options "0" by default
								}
								if (item.mandatory === 0) {
									optionals.push(item)
									optionals_consents.push(0); //filling all options "0" by default
								}
							}
						});
					});
					//console.log("policies: ", 'mandatories: ', mandatories, 'optionals: ', optionals, mandatories_consents, optionals_consents);
					this.setState({ mandatories, optionals, mandatories_consents, optionals_consents, privacy_id, terms_sci_id });
					this.setState({ loadedData: true });
				}
			});
	} catch (error) {}
}


	renderMandatoryContent = () => {
		const { mandatories } = this.state;
		//console.log('renderMandatoryContent: ', 'mandatories: ', mandatories);
		return mandatories.map(function (item, index) {
			let that = this;
			//console.log(item);
			return (
				item.label === "terms_sci" ?
					<div className="row mb-5" key={ index }> 
						<div className="col-12">
							<p>
								{ tr.t("Accepti") }
								{" "}
								<a href="https://www.mypass.ski/termini-uso/" target="_blank" rel="nofollow" className="sn_underline">
									{ tr.t("Terms") }
								</a>
								{" "}
								{ tr.t("Andthe") }
								<a href="https://www.mypass.ski/privacy/" target="_blank" rel="nofollow" className="sn_underline">
									{ tr.t("Privacydisclaim") }
								</a>
								{" "}<br/>
								{ tr.t("Mandatory") }
							</p>
              <RoundCheckbox index={index} phoneView={isMobile} checkText={tr.t("Accept")} isChecked={this.state.mandatories_consents[index] === 1 ? true : false } onClick={this.onMandatoryChange} />
            </div>
          </div>
          :
        	<div className="row mb-5" key={ index }>
						<div className="col-12">
							<p>{ item.text }</p>
              <RoundCheckbox index={index} phoneView={isMobile} checkText={tr.t("Accept")} isChecked={this.state.mandatories_consents[index] === 1 ? true : false } onClick={this.onMandatoryChange} />
            </div>
          </div>
      )
    }, this)
  }

  onMandatoryChange = (e) => {
    var checkbox = document.getElementById(e.target.id);
    let mandatories_consents = this.state.mandatories_consents;
    mandatories_consents[e.target.id] = Number(checkbox.checked);
    this.setState({ mandatories_consents });
  }

  renderOptionalContent = () => {

    const { optionals } = this.state;
    //console.log('renderOptionalContent: ', 'optionals: ', optionals);

    return optionals.map(function (item, index) {
      let that = this;
      //console.log(item);
      return (
        <div key={ index } className="row mb-5">
        <div className="col-12">
          <p>{ item.text }</p>
          <HorizontalRadioButton index={ index } rPhoneView={ isMobile } controller={ that.onOptionChange.bind(that) }/>
          </div>
        </div>
      )
    }, this)
  }

  onOptionChange = (e) => {
    e.preventDefault();
    //console.log(e.target);
    let optionals_consents = this.state.optionals_consents;
    optionals_consents[e.target.name] = Number(e.target.value);
    this.setState({ optionals_consents });
  }

  // handlers
  // open privacy popup, fill content
  handelOnClickPrivacy = (e) => {
    e.preventDefault();
    this.setState({ privacy: contracts.privacy.text });
    this.setState({ privacyTitle: contracts.privacy.title });
    this.setState({ showPrivacy: true });
    this.setState({ showTerms: false });
  }

  // open terms&condition popup, fill content
  handelOnClickTerms = (e) => {
    e.preventDefault();
    this.setState({ terms: contracts.terms.text });
    this.setState({ termsTitle: contracts.terms.title });
    this.setState({ showTerms: true })
    this.setState({ showPrivacy: false })
  }

  // check if form can be submitted
  // check only first 2 checkbox, mandatory.
  //return bool result
  canBeSubmitted = () => {
    const { mandatories_consents } = this.state;
    const result = mandatories_consents.every(v => v === 1);
    return result;
  }

  getConsent = () => {
    const { privacy_id, terms_sci_id } = this.state;

    let consent = this.getMandatoryConsent() +
      this.getOptionalConsent() +
      + terms_sci_id + ':1,'
      + privacy_id + ':1';
    //console.log('CONSENT', consent);
    return consent;
  }

  getMandatoryConsent = () => {
    const { privacy_id, terms_sci_id, mandatories, mandatories_consents } = this.state;

    let mandatory_cons = '';
    //console.log(mandatories_consents, "++", mandatories);

    for (var i in mandatories) {
      if (mandatories[i].id != privacy_id && mandatories[i].id != terms_sci_id)
        mandatory_cons = mandatory_cons + mandatories[i].id + ":" + mandatories_consents[i] + ","
      //console.log("mandatory_cons: 1", mandatory_cons);

    }
    //console.log("mandatory_cons: 2", mandatory_cons);
    return mandatory_cons;
  }
  getOptionalConsent = () => {
    const { optionals_consents, optionals } = this.state;
    let optionals_cons = '';

    //console.log(optionals_consents, "+", optionals);

    for (var i in optionals) {
      optionals_cons = optionals_cons + optionals[i].id + ":" + optionals_consents[i] + ","
      //console.log("optionals_cons: 1", optionals_cons);

    }
    //console.log("optionals_cons: 2", optionals_cons);

    return optionals_cons;
  }

  // gotoBenvenuto

  gotoBenvenutol = (e) => {
    e.preventDefault();

    try {
      let access_token = cookies.get('access_token');

      let params = {
        portal: "sci",
        consents: this.getConsent()
      }

      //console.log("gotoBenvenutol: ", params);


      acceptContracts(this, access_token, params).then((response) => {
        //console.log("acceptContracts: response: ", response)

        if (response == null) {

          return;
        }

        if (response.status == "fail") {
          //console.log("acceptContracts: !!FAIL!!: ", response.message)
          // alert(response.status)
          this.handleAlert(response.status);
        }

        if (response.status == "success") {
          // alert(response.status)
          if(this.state.backto == 'userarea'){
            return this.props.history.push('/');
        }else{
            // create a new cart
            MPWorkFlow.getInstance().workflowCreat(this, { force: 1, workflow: 'skicart' }).then(response => {
                //console.log("[Termini] @workflowCreat #response: ", response);
                if (response.status === "success") {
                    // new cart can be generated
                    // storing cart in storage
                    MPWorkFlow.getInstance().updateWorkflow(this,response.data);
                return this.props.history.push('/WelcomeScreen'); //cart is empty user needs to restart the purchase
              } else if (response.status === "fail") {
                // a cart already exists
                // call state and update the storage
                this.handleAlert(response.message);
                // this.setState({
                //     errorFlg: true,
                //     errmsg: response.message
                // })
              }
            });
          }

        }

        else {
          //console.log(response);
          return;
        }

      });

    } catch (error) {
      //console.log('ERROR! : ', error);
    }

    return;
  }

  // LOGOUT! if user decides to  close the terms
  logout = () => {
    try {
      // fill storage w/ user data.
      userLogoutFetch(this).then((response) => {
        //console.log(response);
        localStorage.clear();
        cookies.remove('access_token');
        return this.props.history.push('/');
      });
    } catch (e) {
      //console.log(e);
    }
  }



  // ** 
  radio1 = () => {

    this.setState({ radio1: true, radio2: false })
  }

  radio2 = () => {
    this.setState({ radio1: false, radio2: true })
  }

  radio3 = () => {
    this.setState({ radio3: true, radio4: false })
  }

  radio4 = () => {
    this.setState({ radio3: false, radio4: true })
  }

  handleClost = () => {
    this.setState({ modal: true, alertClost: true })
  }

  alertResponse(info) {
    switch (info.type) {
      case "closeButton":
        this.setState({ modal: false, alertClost: false, inScreenPopupShow: false })
        break;
      case "actionButton":
        if (info.option1 === "gotologin") {
          this.setState({ modal: false, alertClost: false })
          this.logout();
          break;
        }
        if (info.option2 === "gotosite") {
          this.setState({ modal: false, alertClost: false })
          break;
        }
        if (info.option1 === "attention") {
          this.setState({ inScreenPopupShow: false })
          break;
        }
    }
  }

  // Default browser alert function replacement
  handleAlert = (incomingMsg) => {
    //console.log("Incoming message:", incomingMsg);
    this.setState({
      inScreenPopupShow: true,
      inScreenPopupMsg: incomingMsg,
    })
  }

  render() {
    const userInfo = this.props.userInfo;
    return (
      <Router>
        <div>
          {
            this.state.loadedData && <div>
            <BrowserView>
              <div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
                <div className="row flex-nowrap">
                  <div className="col-2 d-flex align-items-center">
                  </div>
                  <div className="col-8 d-flex align-items-center justify-content-center">
                    <img className="sn_mobile_top_row_logo" src={ logo } />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-end">
                    <div className="sn_exit">
                      <a onClick={ this.handleClost }>
                        <img src={ clos } />
                      </a>
                    </div>		
                  </div>
                </div>
              </div>
              <div className="sn_topbar"><TopBar step={ this.state.step }/></div>
              <div className="sn_overlay d-lg-none"></div>
              <div className="sn_terms">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-10 col-xl-6 mx-auto">
                      <div className="sn_register__container p-3 p-md-4 p-lg-5">
                        <div className="row">
                          <div className="col-12 d-none d-lg-flex justify-content-end">
                            <div className="sn_exit">
                              <a onClick={ this.handleClost }>
                                <img src={ clos } />
                              </a>
                            </div>	
                          </div>
                        </div>
                        <h3 className="mb-3 text-center">{ tr.t("Conditions") }</h3>
                        <div>
                          { this.state.mandatories && this.renderMandatoryContent() }
                          { this.state.optionals && this.renderOptionalContent() }
                        </div>
                        <div className="row">
                          <div className="col-12 d-flex justify-content-center justify-content-sm-end">
                            <button disabled={!this.canBeSubmitted()} className="sn_btn mb-3 mb-sm-0" onClick={this.gotoBenvenutol}>{ tr.t("Next") }</button>
                          </div>
                        </div>
                        <div className="row d-lg-none mt-5">
                          <div className="col-12">
                            <ProgressBullets step={ this.state.step } />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </BrowserView>
            <MobileView>
              <div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
                <div className="row flex-nowrap">
                  <div className="col-2 d-flex align-items-center">
                  </div>
                  <div className="col-8 d-flex align-items-center justify-content-center">
                    <img className="sn_mobile_top_row_logo" src={ logo } />
                  </div>
                  <div className="col-2 d-flex align-items-center justify-content-end">
                    <div className="sn_exit">
                      <a onClick={ this.handleClost }>
                        <img src={ clos } />
                      </a>
                    </div>		
                  </div>
                </div>
              </div>
              <div className="sn_topbar"><TopBar step={ this.state.step }/></div>
              <div className="sn_overlay d-lg-none"></div>
              <div className="sn_terms">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-10 col-xl-6 mx-auto">
                      <div className="sn_register__container p-3 p-md-4 p-lg-5">
                        <div className="row">
                          <div className="col-12 d-none d-lg-flex justify-content-end">
                            <div className="sn_exit">
                              <a onClick={ this.handleClost }>
                                <img src={ clos } />
                              </a>
                            </div>	
                          </div>
                        </div>
                        <h3 className="mb-3 text-center">{ tr.t("Conditions") }</h3>
                        <div>
                          { this.state.mandatories && this.renderMandatoryContent() }
                          { this.state.optionals && this.renderOptionalContent() }
                        </div>
                        <div className="row">
                          <div className="col-12 d-flex justify-content-center justify-content-sm-end">
                            <button disabled={!this.canBeSubmitted()} className="sn_btn mb-3 mb-sm-0" onClick={this.gotoBenvenutol}>{ tr.t("Next") }</button>
                          </div>
                        </div>
                        <div className="row d-lg-none mt-5">
                          <div className="col-12">
                            <ProgressBullets step={ this.state.step } />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </MobileView>
            {
              this.state.modal ?
              <div className="containerModal">
              {
                this.state.alertClost ?
                <AlertPnl textbar1={tr.t("Surecancel")} secondbar={true} textbar2={tr.t("Allost")} doublebtnhor={true} textbtn1={tr.t("Returnlogin")} textbtn2={tr.t("Returnsite")} option1={"gotologin"} option2={"gotosite"} callback={this.alertResponse.bind(this)} /> : null
              }
              </div> : null
            }
            {
              this.state.inScreenPopupShow ?
              <div className="containerModal">
              {
                this.state.inScreenPopupShow ?
                <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
              }
              </div> : null
            }
        </div>
        }
        </div>
      </Router>
    );
}
}

export default Termini;



// WEBPACK FOOTER //
// ./src/screens/Termini/Termini.js